export const palette = {
  primary: {
    main: "#424242",
    400: "#bdbdbd",
    600: "#757575",
    700: "#616161",
  },
};
